<div class="tasks-container">
  <div class="header">
    <h1>Todas as tarefas</h1>
    <button mat-raised-button color="primary" (click)="navigateToCreateTask()">
      <mat-icon>add_circle</mat-icon>
      Criar tarefa
    </button>
  </div>

  @if (isLoading) {
    <div class="loading-container">
      <mat-spinner diameter="40"></mat-spinner>
    </div>
  }

  @if (!isLoading) {
    <div>
      @if (tasks.length === 0) {
        <div class="no-tasks">
          <p>Nenhuma tarefa</p>
        </div>
      }
      @if (tasks.length > 0) {
        <div>
          @for (task of tasks; track task) {
            <app-task-summary-tile [task]="task" (taskClick)="navigateToTask($event)">
            </app-task-summary-tile>
          }
        </div>
      }
    </div>
  }

  @if (tasks.length > 0) {
    <mat-paginator [length]="totalElements" [(pageSize)]="pageSize"
      [pageSizeOptions]="[5, 10, 25, 100]" (page)="onPageChange($event)">
    </mat-paginator>
  }
</div>